export default __webpack_public_path__ + "static/media/FI.dd9b4eb9.svg";